import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';

export const GET_CUSTOMER_DETAILS_REQUEST = 'GET_CUSTOMER_DETAILS_REQUEST';
export const GET_CUSTOMER_DETAILS_SUCCESS = 'GET_CUSTOMER_DETAILS_SUCCESS';
export const GET_CUSTOMER_DETAILS_FAILURE = 'GET_CUSTOMER_DETAILS_FAILURE';
export const GET_CUSTOMER_DETAILS_CLEAR = 'GET_CUSTOMER_DETAILS_CLEAR';

function request(customerId, rowId) {
  return {
    type: GET_CUSTOMER_DETAILS_REQUEST,
    rowId,
    customerId
  };
}

function receive(customerDetails, customerId, rowId) {
  return {
    type: GET_CUSTOMER_DETAILS_SUCCESS,
    customerId,
    rowId,
    customerDetails
  };
}

function reject(customerId, rowId, getCustomerDetailsError) {
  return {
    type: GET_CUSTOMER_DETAILS_FAILURE,
    customerId,
    rowId,
    getCustomerDetailsError
  };
}

function clear(customerId, rowId) {
  return {
    type: GET_CUSTOMER_DETAILS_CLEAR,
    customerId,
    rowId
  };
}

export function getCustomerDetails(customerId, rowId) {
  return (dispatch) => {
    dispatch(request(customerId, rowId));
    return ApiService
      .getCustomerDetails(customerId, rowId)
      .then((response) => {
        dispatch(receive(response.data, customerId, rowId));
      }).catch((error) => {
        if (error && error.response) {
          error.response.data = { code: error.response.status, message: 'Sorry, we were unable to retrieve your customer details at this time, please try again later' };
        }
        dispatch(handleException(error, null, true));
        dispatch(reject(customerId, rowId, error.response.data));
      });
  };
}

export function clearCustomerDetails(customerId, rowId) {
  return (dispatch) => {
    dispatch(clear(customerId, rowId));
  };
}
